import angular from 'angular';

import { ShipmentTrackingQualityCellComponent } from './shipment-tracking-quality-cell.component';

angular
  .module('app.global.shipment-cells.tracking-quality', [])
  .component('shipmentTrackingQualityCell', ShipmentTrackingQualityCellComponent);
